export default "__VITE_ASSET__b703fdeb__"